<template>
<div class="chapter">
<div class="inner_page">
<p class="block_6"> </p>
<p class="block_6"> </p>
<p class="block_6"> </p>
<p class="block_6"> </p>
<h1 class="block_1" id="toc_id_2">Dedication</h1>
<p class="block_6"> </p>
<p class="block_6"> </p>
<p class="block_6"> </p>
<p class="block_7">For Chrystelle Al.</p>
<p class="block_5" id="calibre_pb_1"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?ac6ff81c